import { Grid } from '@mui/material'

import GridIconButton from './GridIconButton'

const GridLinksHomepage = ({ index, x, values, onChange = () => {} }) => {
  const removeIndex = () =>
    onChange([...values?.slice(0, index), ...values?.slice(index + 1)])

  const xUrl = (
    <a href={x.url} rel='noopener noreferrer' target='_blank'>
      {x.url}
    </a>
  )

  return (
    <Grid container spacing={2} alignItems='center' sx={{ width: '100%' }}>
      <Grid size='grow' sx={{ overflowWrap: 'break-word' }}>
        {x.titolo}: {xUrl}
      </Grid>
      <GridIconButton type='delete' size='auto' onClick={removeIndex} />
    </Grid>
  )
}

export default GridLinksHomepage
